export const AWAITING_PARTICIPANT = 'awaitingParticipantStatus'
export const AWAITING_PARTICIPANT_RECONNECT = 'awaitingParticipantReconnectStatus'
export const CONNECTING = 'connectingStatus'
export const PROCESSING_END_VISIT = 'processingEndVisitStatus'
export const VISIT_SUSPENDED_STATUS = 'visitSuspendedStatus'
